module.exports = __webpack_public_path__ + "static/media/44.de7c8c55.png";